const quizQuestions = [
  {
    question:
      'When someone with a disability is unable to access stairs; how do we now view the problem?',
    answers: [
      {
        type: 'correct',
        content: 'There is no ramp so the design is not accessible.'
      },
      {
        type: 'wrong1',
        content: 'Their physical disability is the problem.'
      },
      {
        type: 'wrong2',
        content: 'There is no problem.'
      },
      {
        type: 'wrong3',
        content: 'All of the above. '
      }
    ]
  },
  {
    question:
      'What are the three main impairments someone with a disability could have?',
    answers: [
      {
        type: 'correct',
        content: 'Physical, learning or mental impairment.'
      },
      {
        type: 'wrong1',
        content: 'Depression, use of a wheelchair and vision loss.'
      },
      {
        type: 'wrong2',
        content: 'Physical, spiritual and social impairment.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question: 'What could be the cause of a disability?',
    answers: [
      {
        type: 'correct',
        content: 'All of the above.'
      },
      {
        type: 'wrong1',
        content: 'They are born with a disability.'
      },
      {
        type: 'wrong2',
        content: 'They can be caused by an accident.'
      },
      {
        type: 'wrong3',
        content: 'They can be developed over time.'
      }
    ]
  },
  {
    question: 'What is Accessibility?',
    answers: [
      {
        type: 'correct',
        content:
          'A term to describe whether something is able to be accessed including products, services and environments.'
      },
      {
        type: 'wrong1',
        content:
          'The ability to gain exclusive access as a person with a disability.'
      },
      {
        type: 'wrong2',
        content:
          'Something that only people with a disability are affected by.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question: 'What are the five common barriers to Accessibility?',
    answers: [
      {
        type: 'correct',
        content:
          'Attitude, Systemic, Physical, Information and Communication, Technology.'
      },
      {
        type: 'wrong1',
        content: 'Feelings, Physical, Stereotypes, Buildings, People.'
      },
      {
        type: 'wrong2',
        content:
          'Perceptions, Feelings, Physical, Technology and Communication.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question:
      'What is the main statement of the Ontario Human Rights Code?',
    answers: [
      {
        type: 'correct',
        content:
          'It is a fundamental human right for all people to be free from discrimination and to receive equal treatment where they work, live, and receive services. '
      },
      {
        type: 'wrong1',
        content: 'You can not deny service animals. '
      },
      {
        type: 'wrong2',
        content: 'For Ontario to be fully accessible by 2025.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question:
      'What is the main purpose of The Accessibility for Ontarians with Disabilities Act (AODA)?',
    answers: [
      {
        type: 'correct',
        content:
          'To develop and enforce accessibility standards by identifying, removing and preventing barriers for people with disabilities in areas of daily life. Its goal is to transition Ontario to be completely accessible by 2025.'
      },
      {
        type: 'wrong1',
        content: 'To protect the human rights of Ontarians.'
      },
      {
        type: 'wrong2',
        content: 'To uphold freedom of speech.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question: 'What are the five Accessibility Standards of the AODA?',
    answers: [
      {
        type: 'correct',
        content:
          'Customer Service, Information and Communication, Built Environment, Employment Accessibility, Transportation Standard.'
      },
      {
        type: 'wrong1',
        content:
          'Customer Service, Information and Communication, Freedom of Speech, Ability to live as desired. '
      },
      {
        type: 'wrong2',
        content:
          'Freedom from discrimination, Transportation Standard, Freedom of Speech, Ability to live as desired, Employment Accessibility. '
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question:
      'What are some common limiting stereotypes commonly held about people with a disability?',
    answers: [
      {
        type: 'correct',
        content: 'All of the above.'
      },
      {
        type: 'wrong1',
        content: 'They have no social life.'
      },
      {
        type: 'wrong2',
        content: 'They don’t work.'
      },
      {
        type: 'wrong3',
        content: 'They are not active.'
      }
    ]
  },
  {
    question:
      'What are the three key tools for accessible customer service?',
    answers: [
      {
        type: 'correct',
        content: 'Person First, Ask First, Be Considerate.'
      },
      {
        type: 'wrong1',
        content: 'Person First, Do As You Feel, Be Considerate.'
      },
      {
        type: 'wrong2',
        content: 'Do As You Feel, Act With Confidence, Be Considerate.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question: 'What does the Person First Framework cover?',
    answers: [
      {
        type: 'correct',
        content:
          'We should treat and talk to people as individuals and use ‘person first’ language.'
      },
      {
        type: 'wrong1',
        content: 'We should always look out for ourselves first.'
      },
      {
        type: 'wrong2',
        content: 'Always prioritise other people before yourself first.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question:
      'What are appropriate conversation topics when interacting with a person with a disability?',
    answers: [
      {
        type: 'correct',
        content: 'Music, events, sports and weather.'
      },
      {
        type: 'wrong1',
        content: 'Someone’s disability.'
      },
      {
        type: 'wrong2',
        content: 'Religion, sex and politics.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question: 'Who is a support person?',
    answers: [
      {
        type: 'correct',
        content:
          'Someone who may accompany a person with a disability to help with communication, mobility, personal care or access. '
      },
      {
        type: 'wrong1',
        content: 'Somebody who assists with emotional problems.'
      },
      {
        type: 'wrong2',
        content: 'Anybody accompanying a person with a disability. '
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question:
      'How should you leave the vehicle when removing the wheelchair?',
    answers: [
      {
        type: 'correct',
        content:
          'Descend down the ramp backwards, facing the vehicle so the weight of the wheelchair is supported'
      },
      {
        type: 'wrong1',
        content: 'Stroll forward down the ramp.'
      },
      {
        type: 'wrong2',
        content: 'In any way you like, it does not matter.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question: 'What equipment do we need to secure a wheelchair?',
    answers: [
      {
        type: 'correct',
        content: 'Four retractors, one lap belt, one shoulder belt.'
      },
      {
        type: 'wrong1',
        content: 'Two retractors, two lap belt, one shoulder belt.'
      },
      {
        type: 'wrong2',
        content: 'Gloves, a belt, and a backpack.'
      },
      {
        type: 'wrong3',
        content: 'All of the above.'
      }
    ]
  },
  {
    question:
      'Which direction must the wheelchair face when in the vehicle?',
    answers: [
      {
        type: 'correct',
        content: 'It must always face forward and be locked.'
      },
      {
        type: 'wrong1',
        content: 'It must face forward and should not be locked.'
      },
      {
        type: 'wrong2',
        content: 'It can face in any direction.'
      },
      {
        type: 'wrong3',
        content: 'It must face backward facing the car trunk.'
      }
    ]
  },
  {
    question: 'In which order should the passenger be secured?',
    answers: [
      {
        type: 'correct',
        content:
          'Attach the lap belt, then the shoulder belt and tighten both belts.'
      },
      {
        type: 'wrong1',
        content: 'It doesn’t matter which order the passenger is secured.'
      },
      {
        type: 'wrong2',
        content:
          'Attach the shoulder belt, then the lap belt and tighten both belts.'
      },
      {
        type: 'wrong3',
        content:
          'The passenger does not have to be secured, it is optional.'
      }
    ]
  },
  {
    question: 'Where should you pick up a passenger?',
    answers: [
      {
        type: 'correct',
        content:
          'Flat, level surfaces away from traffic, ice, puddles, trees, and traffic.'
      },
      {
        type: 'wrong1',
        content: 'The closest intersection.'
      },
      {
        type: 'wrong2',
        content: 'It doesn’t matter where.'
      },
      {
        type: 'wrong3',
        content: 'As close to them as possible.'
      }
    ]
  },
  {
    question: 'What should you do if a rider does not want to be secured?',
    answers: [
      {
        type: 'correct',
        content:
          'Drivers should cancel the trip and submit a claim to receive a reward for the cancelled trip.'
      },
      {
        type: 'wrong1',
        content: 'Allow them to ride unsecured with their wheel locks on.'
      },
      {
        type: 'wrong2',
        content: 'Allow them to ride unsecured holding on to the chair.'
      },
      {
        type: 'wrong3',
        content: 'It is optional.'
      }
    ]
  },
  {
    question:
      'If you are unsure if a passenger needs assistance, what should you do?',
    answers: [
      {
        type: 'correct',
        content: 'Always ask first to see if assistance is required.'
      },
      {
        type: 'wrong1',
        content: 'Always offer assistance as it is polite to do so.'
      },
      {
        type: 'wrong2',
        content: 'Assume a passenger never needs help.'
      },
      {
        type: 'wrong3',
        content: 'Never leave your seat.'
      }
    ]
  }
];

export default quizQuestions;



// WEBPACK FOOTER //
// ./src/components/NewExam/quizQuestions.js